import { featureFlags } from '@seen/core/featureFlags'
import type { JSX } from 'react'
import { DayCenterScheduleDialogV1 } from '#src/components/patient/detail-content/day-center-schedule/DayCenterScheduleDialogV1.tsx'
import {
  DayCenterScheduleDialogV2,
  type DayCenterScheduleDialogV2Props,
} from '#src/components/patient/detail-content/day-center-schedule/DayCenterScheduleDialogV2.tsx'
import { useFeatureFlag } from '#src/hooks/useFeatureFlag.ts'

export type DayCenterScheduleDialogProps = DayCenterScheduleDialogV2Props

// Picks the day center schedule modal for the current user. Both versions take
// the same props, so the flag stays here rather than at each of the three
// places the modal is opened from.
export function DayCenterScheduleDialog(
  props: DayCenterScheduleDialogProps
): JSX.Element {
  const showV2 = useFeatureFlag(featureFlags.dayCenterScheduleV2)
  return showV2 ? (
    <DayCenterScheduleDialogV2 {...props} />
  ) : (
    <DayCenterScheduleDialogV1 {...props} />
  )
}
